import React, { useEffect, useState } from "react"; 
import { GoSignOut } from "react-icons/go";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  Input,
  HStack,
  Button,
  TableContainer,
  Text,
  Flex,
  RadioGroup,
  Radio,
  Image,
  Spinner,
} from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import {
  RiArrowRightSFill,
  RiArrowLeftSFill,
  RiArrowDownSFill,
  RiArrowUpSFill,
} from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../api";

const Dashboard = () => {
  const [searchInput, setSearchInput] = useState("");
  const [data, setData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState();
  const [totalRecords, setTotalRecordes] = useState();
  const rowsPerPage = 7;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const access_token = localStorage.getItem("access_token");

      const params = {
        timeRange: selectedDuration,
        status: selectedStatus,
        search: searchInput,
        page: currentPage,
        size: rowsPerPage,
      };
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(
          ([_, value]) => value !== undefined && value !== null && value !== "",
        ),
      );
      try {
        const response = await axios.get(`${BASE_URL}/payment/history`, {
          params: filteredParams, // Use the filtered params
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        });
        if (response.status === 200) {
          setData(response.data.data);
          setTotalPages(response.data.pagination.totalPage);
          setTotalRecordes(response.data.pagination.totalRecords);
          setLoading(false);
        } else {
          console.error("Error fetching Data");
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching Data:", error);
      }
    };
    fetchData();
  }, [currentPage, searchInput, selectedDuration, selectedStatus]);

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <>
      <Box
        px={{ md: "30px", lg: "36px" }}
        w="100%"
        py={2}
        bg="#F7F9FF"
        h="100vh"
      >
        <HStack gap="4" w="70%">
          <Link to="/">
            <Image
              mx={{ md: "10px", lg: "15px" }}
              justifySelf={"start"}
              w={"70px"}
              src={"/assets/digital-bikana.png"}
            />
          </Link>
          <Flex w="60%">
            <Input
              shadow={"md"}
              rounded={"lg"}
              border="1px"
              borderColor="gray.300"
              px="8"
              placeholder={`Search Name or Email`}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <Box pos="absolute" mt="3" ml="2" textColor="gray.500">
              <FiSearch />
            </Box>
          </Flex>
          <Flex direction="column">
            <Flex
              direction="row"
              bg="gray.50"
              border="1px"
              shadow="lg"
              justifyContent="space-between"
              w="44"
              borderColor="gray.300"
              alignItems="center"
              rounded="lg"
              p="2"
              onClick={() => setShowFilter(!showFilter)}
              _hover={{ cursor: "pointer" }}
            >
              <Text>Filters</Text>
              {showFilter === false ? <RiArrowDownSFill /> : <RiArrowUpSFill />}
            </Flex>

            {showFilter && (
              <Box
                position="absolute"
                mt="12"
                w="44"
                shadow="xl"
                zIndex="100"
                bg="white"
                border="1px"
                borderColor="gray.300"
                rounded="lg"
                px="6"
                py="4"
              >
                <Text fontWeight="bold">Duration</Text>
                <RadioGroup
                  onChange={setSelectedDuration}
                  value={selectedDuration}
                >
                  <VStack align="start" mt="2">
                    <Radio value="DAY">Today</Radio>
                    <Radio value="WEEK">Last Week</Radio>
                    <Radio value="MONTH">Last Month</Radio>
                  </VStack>
                </RadioGroup>
                <Text fontWeight="bold" mt="4">
                  Status
                </Text>
                <RadioGroup onChange={setSelectedStatus} value={selectedStatus}>
                  <VStack align="start" mt="2">
                    <Radio value="COMPLETED">Paid</Radio>
                    <Radio value="PENDING">Pending</Radio>
                  </VStack>
                </RadioGroup>

                <Text
                  textAlign="center"
                  textColor="blue.500"
                  fontSize="sm"
                  mt={"6"}
                  onClick={() => {
                    setSelectedStatus("");
                    setSelectedDuration("");
                  }}
                  _hover={{ cursor: "pointer" }}
                >
                  Clear Filters
                </Text>
              </Box>
            )}
          </Flex>
          <Flex
            alignItems="center"
            gap="2"
            cursor="pointer"
            justifySelf="end"
            _hover={{ textColor: "gray.800" }}
            onClick={() => {
              localStorage.removeItem("access_token");
              navigate("/login");
            }}
          >
            <GoSignOut /> Logout
          </Flex>
        </HStack>

        {/* <HStack gap='2' py='4'>
          <Box bg='#F0FDFA' w='full' p='4' rounded='lg' border='1px' borderColor='gray.300' >
            <Text fontWeight='semibold' >Total Payment</Text>
            <Text fontWeight='semibold' fontSize='2xl' >₹ 50000</Text>
          </Box>
          <Box bg='#FFDAD6' w='full' p='4' rounded='lg' border='1px' borderColor='gray.300' >
            <Text fontWeight='semibold' >Pending Payment</Text>
            <Text fontWeight='semibold' fontSize='2xl' >₹ 29000</Text>
          </Box>
          <Box bg='#C8E2FF' w='full' p='4' rounded='lg' border='1px' borderColor='gray.300' >
            <Text fontWeight='semibold' >No Of Transactions</Text>
            <Text fontWeight='semibold' fontSize='2xl' >515</Text>
          </Box>

        </HStack> */}
        <TableContainer
          borderRadius="lg"
          border="1px solid"
          borderColor="gray.300"
          shadow="lg"
          mt={6}
        >
          <Box overflowX="auto">
            <Table
              variant="unstyled"
              colorScheme=""
              bg="white"
              size={{ md: "sm", lg: "md", xl: "lg" }}
              maxWidth={"100%"}
              // justifySelf={"center"}
              shadow={"lg"}
            >
              <Thead>
                <Tr
                  borderBottom="1px"
                  h="12"
                  bg="gray.50"
                  borderColor="gray.300"
                >
                  <Th>#</Th>
                  <Th>Name</Th>
                  <Th>Email</Th>
                  <Th>Phone Number</Th>
                  <Th>Method</Th>
                  <Th>Payment Date-Time</Th>
                  <Th>Amount</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {loading === true ? (
                  <Tr>
                    <Td colSpan="9" textAlign="center">
                      <Spinner
                        thickness="5px"
                        size="xl"
                        color="blue.600"
                        emptyColor="gray.300"
                        speed="0.65s"
                      />
                    </Td>
                  </Tr>
                ) : (
                  <>
                    {data?.length > 0 ? (
                      data?.map((item, index) => (
                        <Tr
                          key={item.id}
                          borderBottom="1px"
                          borderColor="gray.300"
                        >
                          <Td>{(currentPage - 1) * rowsPerPage + index + 1}</Td>
                          <Td>{item.user.name}</Td>
                          <Td>{item.user.email}</Td>
                          <Td>{item.user.phone}</Td>
                          <Td>
                            {item?.payment_instrument[0]
                              ? item?.payment_instrument[0].type
                              : "No Data"}
                          </Td>
                          <Td>
                            {formatDate(item.created_at)} -{" "}
                            {new Date(item.created_at).toLocaleTimeString(
                              "en-US",
                              {
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              },
                            )}
                          </Td>
                          <Td>₹ {item.amount}</Td>
                          <Td
                            textColor={
                              item.status === "PAID" ? "green.500" : "red.500"
                            }
                          >
                            {item.status}
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan="9" textAlign="center">
                          No data found
                        </Td>
                      </Tr>
                    )}
                  </>
                )}
              </Tbody>
            </Table>
          </Box>
        </TableContainer>
        <Flex
          bg="white"
          w="full"
          px="4"
          py="2"
          mt="8"
          shadow="md"
          direction="row"
          rounded="xl"
          justifyContent="space-between"
        >
          <Box alignContent="center">
            <Text>
              Showing{" "}
              {totalRecords > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0}-
              {totalRecords > 0
                ? currentPage === totalPages || totalRecords <= rowsPerPage
                  ? totalRecords || 0
                  : currentPage * rowsPerPage
                : 0}{" "}
              of {totalRecords || 0}
            </Text>
          </Box>

          <Box>
            {!loading && (
              <>
                <HStack spacing={2} textAlign={"center"} p={2} rounded={"lg"}>
                  <Button
                    size="sm"
                    rounded={"lg"}
                    onClick={() => handlePageChange(currentPage - 1)}
                    isDisabled={currentPage === 1}
                    bg={"#E8F2FF"}
                    _hover={{ shadow: "lg" }}
                  >
                    <RiArrowLeftSFill />
                  </Button>

                  {/* Logic for Pagination Buttons */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter((page) => {
                      // Always show the first and last pages
                      if (page === 1 || page === totalPages) return true;

                      // Show pages around the current page
                      if (page >= currentPage - 1 && page <= currentPage + 1)
                        return true;

                      // Otherwise, hide the page
                      return false;
                    })
                    .map((page, index, array) => (
                      <React.Fragment key={page}>
                        {index > 0 && page > array[index - 1] + 1 && (
                          <span>...</span>
                        )}
                        <Button
                          rounded={"lg"}
                          size="sm"
                          onClick={() => handlePageChange(page)}
                          colorScheme={
                            currentPage === page ? "blue" : "blackAlpha"
                          }
                        >
                          {page}
                        </Button>
                      </React.Fragment>
                    ))}
                  <Button
                    size="sm"
                    rounded={"lg"}
                    onClick={() => handlePageChange(currentPage + 1)}
                    bg={"#E8F2FF"}
                    isDisabled={currentPage === totalPages}
                    _hover={{ shadow: "lg" }}
                  >
                    <RiArrowRightSFill />
                  </Button>
                </HStack>
              </>
            )}
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default Dashboard;
